import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from '../SectionHeading';
const groups = [{
  title: '6 Premium Volumes',
  items: ['Case Assessment', 'Digital Planning', 'Installation Control', 'Attachments & IPR Control', 'Follow-Up & Case Control', 'Refinement & Finishing']
}, {
  title: '5 Professional Bonuses',
  items: ['Aligner Quick Reference Cards™', 'Case Control Tracker™', 'Pre-Installation Master Checklist™', 'Refinement Review Kit™', 'Aligner Clinical Desk™']
}, {
  title: 'Plus',
  items: ['30+ protocols and checklists', 'Case tracking tools', 'Planning frameworks', 'Review tools', 'Decision maps', 'Documentation tools', 'Quick-reference resources']
}];
export function WhatYouGet() {
  return <section className="w-full bg-white py-14 sm:py-20" data-id="element-315" data-mp="1rtkr2ir0kt47">
      <div className="mx-auto w-full max-w-5xl px-4" data-id="element-316" data-mp="2uz3p2xhjwzqo">
        <SectionHeading eyebrow="⭐ What you get" title="Your complete Aligner Control System™" data-id="element-317" data-mp="2v0on4x32r0ta" />

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-3" data-id="element-318" data-mp="34wrqg69nx5ht">
          {groups.map(group => <div key={group.title} className="flex h-full flex-col rounded-3xl border border-navy-100 bg-cream p-5 sm:p-6" data-id="element-319" data-mp="39vkyvka3e6b4">
              <h3 className="font-display text-lg font-black uppercase tracking-tight text-navy-800" data-id="element-320" data-mp="3dvdcwci994nv">
                {group.title}
              </h3>
              <ul className="mt-4 flex flex-col gap-2" data-id="element-321" data-mp="3nmzls274erng">
                {group.items.map(item => <li key={item} className="flex items-start gap-2 text-sm font-semibold text-navy-700" data-id="element-322" data-mp="3slaug9loiw43">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sky-500" aria-hidden="true" data-id="element-323" data-mp="5hmnym4q5udn" />
                    <span data-id="element-324" data-mp="22iin0uip8rcw">{item}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>

        <div className="mt-10 flex justify-center" data-id="element-325" data-mp="2bacal0wnb2bz">
          <CTAButton label="Get everything for $27" data-id="element-326" data-mp="2bc5jynyn80no" />
        </div>
      </div>
    </section>;
}